<template>
  <div class="container">
    <h1
      class="d-flex justify-content-center mb-3"
      :class="settings.title.class"
      :style="settings.title.style"
    >
      {{ settings.title.text }}
    </h1>
    <span
      class="d-flex justify-content-center mb-5"
      :class="settings.description.class"
      :style="settings.description.style"
    >
      {{ settings.description.text }}
    </span>
    <validation-observer v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(sendPasswordUpdateRequest)">
        <form-field
          :formFields="settings.sub_sections.password_reset.fields"
          :show="true"
          :model="credentials"
          :id-prefix="idPrefix"
        />

        <button
          class="d-flex ml-auto mr-auto mt-3 btn btn-egx-white"
          :class="settings.button.class"
          :style="settings.button.style"
          type="submit"
        >
          {{ settings.button.text }}
        </button>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import { required, min, confirmed } from 'vee-validate/dist/rules';

import router from '../router/index';
import FormField from './form/FormField.vue';

export default {
  name: 'ResetPassword',

  props: {
    settings: {
      type: Object,
      required: true,
    },
  },

  components: {
    FormField,
    ValidationObserver,
  },

  data() {
    return {
      idPrefix: 'password-reset',

      credentials: {
        password: '',
        password_confirmation: '',
        reset_password_token: this.$route.query.t,
      },
    };
  },

  created() {

    extend('required', {
      ...required,
      message: this.settings.sub_sections.password_reset.messages?.required || 'This field is required.',
    });

    extend('min', {
      ...min,
      message: this.settings.sub_sections.password_reset.messages?.min || 'This field must have at least {length} characters.',
    });

    extend('confirmed', {
      ...confirmed,
      message: this.settings.sub_sections.password_reset.messages?.confirmed || 'The confirmation does not match the password.',
    });

    this.$store.dispatch('auth/checktoken', this.credentials)
      .then((response) => {
        if (!response || !response.token) {
          router.push({ name: 'sign-in' });
        }
      })
      .catch((error) => {
        const message = error.response.data.errors[0].title
          || 'There was an error with your request, Please try again in a few minutes';

        router.push({ name: 'sign-in', query: { errorPersist: true } });
        this.$notify({
          group: 'notice-stay',
          type: 'error',
          text: message,
        });
      });
  },

  methods: {
    sendPasswordUpdateRequest() {
      this.$store.dispatch('auth/updatePassword', this.credentials)
        .then((response) => {
          this.$notify({
            group: 'notice',
            text: this.settings.notice_success,
          });
          if (response && response.token) {
            router.push({ name: 'EmailVerification', query: {token: response.token, first_access: true } });
          }
          else {
            router.push({ name: this.settings.next_page });
          }

        })
        .catch((error) => {
          const message = error.response.data.errors[0].title
            || 'There was an error with your request, Please try again in a few minutes';

          this.$notify({
            group: 'notice-stay',
            type: 'error',
            text: message,
          });
        });
    },
  },
};
</script>
